<template>
  <side-base>
    <div class="swrap">
      <div class="shead">
        <search-filter
          :enableLeft="config.enableLeft"
          :enableCampus="config.enableCampus"
          :campus="params.campusList"
          @clickCampus="chooseCampus"
          :enableDate="false"
          placeholder="请输入姓名/手机号后4位"
          :enableSearch="config.enableSearch"
          :searchIcon="config.searchIcon"
          @search="params.name = $event"
          :enableFilter="config.enableFilter"
          @clickFilter="openFilter"
          :hasFilter="hasFilter"
        ></search-filter>

        <div class="toolbar" v-if="showToolBar">
          <div style="color: var(--c1)" @click="toAdd()" v-if="hasAddStu">新增学员</div>
        </div>
      </div>

      <vx-list
        class="smain"
        enable
        :api="api"
        :params="computeParams"
        @load="onLoad"
        firstShowLoading
        ref="vxlist"
      >
        <div class="slist">
          <div class="sitem" v-for="item in listAll" :key="item.id" @click="clickHandler(item)">
            <div class="l sicon">
              <side-icon-select :checked="ids.includes(item.id)" />
            </div>
            <div class="r">
              <div class="r-r van-hairline--bottom">
                <div class="rrln1 an-ellipsis">
                  <div class="rname van-ellipsis">
                    {{ item.name }}
                  </div>
                  <van-tag
                    plain
                    type="primary"
                    color="var(--g5)"
                    style="margin-left: 4px"
                    v-if="item.courseRelation === 0"
                    >不再上课</van-tag
                  >
                </div>
                <div class="rrln2">
                  <span
                    :class="{ 'is-history': (item.status === 6 || item.status === 99),
                      'is-stop': item.status === 7,
                      'is-unpaid': item.status === 0 }"
                    v-if="item.intentionStatus !== 1"
                    >{{ studentsStatusDict[item.status] }}</span
                  >
                  <span v-if="item.intentionStatus === 1" class="audition-tag">意向学员</span>
                  {{ getStudentParentRelation(item.studentParentRelation || []) }}
                </div>
              </div>
            </div>
            <!-- <svg class="vxm-icon buzaiicon" aria-hidden="true" v-if="item.courseRelation === 0">
              <use xlink:href="#vxm-icon-buzaishangke"></use>
            </svg> -->
          </div>
        </div>
        <van-empty
          v-if="listAll.length === 0 && !loading"
          image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
          description="没有找到学员~"
          image-size="128"
          style="margin-top: 20vh"
        ></van-empty>
      </vx-list>
      <side-foot
        @cancel="close"
        @confirm="confirm(getRet())"
        :confirmSubText="config.radio ? '' : `(${list.length})`"
      >
        <select-Base
          :show="!config.radio"
          :ids="ids"
          :list="list"
          :isAll="checkAll"
          @clickAllBtn="checkAll = !checkAll"
        ></select-Base>
      </side-foot>
    </div>
  </side-base>
</template>

<script>
import sideMixin from '@x3/js/side/0_mixin/mixin-select.js';

export default {
  name: 'x3-side-student',
  mixins: [sideMixin],
  inject: ['studentsStatusDict'],
  data() {
    return {
      pageTitle: '选择学员',
      // 是否正在加载数据
      loading: true,

      api: this.$api.studentListList,
      params: {
        // 搜索词
        name: '',
        // 校区ID集合
        campusIds: [],
        campusList: [],
        // 学业状态
        status: [0, 1],
        // 学员课程状态
        courseRelations: [],
        intentionStatus: 0,

        // 课程id集合
        curriculumIds: [],
        curriculumList: [],
        // 班级id集合
        classIds: [],
        classList: [],
        // 在班情况
        classStudentStatus: [1, 2],
      },
      // 配置项
      config: {
        // 是否单选功能
        radio: false,

        // 是否开启新增能力
        enableAdd: false,
        // 是否开启筛选能力
        enableLeft: true,
        enableCampus: true,
        enableDate: false,
        enableSearch: true,
        searchIcon: true,
        enableFilter: true,

        // 是否支持学员类型筛选
        enableIntentionStatus: false,
        // 是否开启学员状态筛选
        enableStudentStatus: true,
        // 是否开启学员课程状态筛选
        enableStudentCourseRelations: false,

        enableMore: false,

        // 班级筛选
        enableClassFilter: false,
      },
    };
  },
  computed: {
    hasAddStu() {
      return this.config.enableAdd && app.permission.op('add_student');
    },
    showToolBar() {
      return this.hasAddStu;
    },
    // 当前是否有筛选
    hasFilter: function () {
      if (this.config.enableMore) {
        let len2 = this.params.curriculumIds.length;
        let len3 = this.params.classIds.length;
        let len = len2 + len3;
        if (len > 0) {
          return true;
        }
        if (this.config.enableIntentionStatus) {
          if (this.params.intentionStatus.toString().length > 0) {
            return true;
          }
        }
        if (this.config.enableStudentStatus) {
          if (this.params.status.length > 0) {
            return true;
          }
        }

        return false;
      } else {
        if (this.config.enableIntentionStatus) {
          if (this.params.intentionStatus.toString().length > 0) {
            return true;
          }
        }
        if (this.config.enableStudentStatus) {
          if (this.params.status.length > 0) {
            return true;
          }
        }
        return false;
      }
    },
    computeParams() {
      const arr = this.params.classStudentStatus;
      return {
        ...this.params,
        classStudentStatus: arr.length === 1 ? arr[0] : 0,
      };
    },
  },
  methods: {
    // 数据加载
    onLoad(list, res) {
      this.listAll = list;
      this.total = res.page.totalCount;
      this.loading = false;
    },
    // 返回联系人方式字符串
    getStudentParentRelation(relationObjs = []) {
      let relationObj = relationObjs[0];
      for (let i = 0, len = relationObjs.length; i < len && len > 1; i++) {
        let r = relationObjs[i];
        if (r.often === true) {
          relationObj = r;
          break;
        }
      }
      if (relationObj) {
        return `${relationObj.relation} ${Vue.filter('desensitization')(relationObj.parentPhone)}`;
      }
      return '';
    },
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList,
      });
      this.params.campusIds = res.ids;
      this.params.campusList = res.list;
    },
    // 打开筛选
    async openFilter() {
      let opts = this.$route.meta.options || {};
      let apiFn = '';
      if (!this.config.enableMore) {
        apiFn = app.x3.side.xsStudentFiltrate;
      } else {
        apiFn = app.x3.side.xsStudentMoreFiltrate;
      }
      console.log(opts);
      let res = await apiFn({
        params: this.params,
        config: {
          enableIntentionStatus: this.config.enableIntentionStatus,
          enableStudentStatus: this.config.enableStudentStatus,
          enableStudentStatusIds: this.config.enableStudentStatusIds,
          enableStudentCourseRelations: this.config.enableStudentCourseRelations,
          enableClassFilter: this.config.enableClassFilter,
        },
        defaultParams: opts.defaultParams,
      });
      this.params = Object.assign(this.params, res.params);
    },
    toAdd() {
      this.$router.push(`/baseStudentInput?onlyAdd=true`);
    },
  },
  created() {
    // 监听学员登记页面响应的登记成功
    this.$onBus('studentInputSuccess', () => {
      this.$refs.vxlist.refresh();
    });
  },
};
</script>

<style lang="scss" scoped>
.swrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .shead {
    .toolbar {
      padding: calc(var(--gap) * 8) calc(var(--gap) * 16);
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--g8);
    }
  }
  .smain {
    flex: 1;
    overflow: auto;
    .slist {
      padding: 0 calc(var(--gap) * 16);
      background: var(--white);
      .sitem {
        position: relative;
        display: flex;
        align-items: center;
        .l.sicon {
          margin-right: calc(var(--gap) * 16);
          padding-top: calc(var(--gap) * 2);
        }
        .r {
          flex: 1;
          display: flex;
          align-items: center;
          overflow: hidden;
          .r-r {
            flex: 1;
            padding: calc(var(--gap) * 10) 0;
            font-size: var(--fs-md);
            line-height: var(--lh-md);
            color: var(--g8);
            overflow: hidden;
            .rrln1 {
              display: flex;
              justify-content: space-between;
              overflow: hidden;
              .rname {
                flex: 1;
                // word-break: break-all;
                // display: flex;
                // align-items: center;
              }
            }
            .rrln2 {
              margin: calc(var(--gap) * 4) 0 0;
              color: var(--g6);
              font-size: var(--fs-sm);
              line-height: var(--lh-sm);
              span {
                margin-right: calc(var(--gap) * 8);
                padding: 0 calc(var(--gap) * 4);
                font-size: var(--fs-sm);
                line-height: var(--lh-sm);
                color: var(--c1);
                border-radius: var(--radius-base);
                background-color: rgba(var(--c1-rgb), 0.12);
                &.audition-tag {
                  color: var(--c4);
                  background-color: none;
                }
                &.is-history {
                  color: var(--g6);
                  background-color: rgba(var(--g6-rgb), 0.12);
                }
                &.is-unpaid  {
                  color: var(--c4);
                  background-color: rgba(var(--c4-rgb), 0.12);
                }
                &.is-stop {
                  color: var(--c3);
                  background-color: rgba(var(--c3-rgb), 0.12);
                }
              }
            }
          }
        }
        // .buzaiicon {
        //   font-size: 44px;
        //   color: var(--g5);
        //   position: absolute;
        //   right: 0px;
        //   top: 10px;
        //   transform: rotate(30deg);
        // }
      }
    }
  }
}
</style>